var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartGuard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 59,
    viewBox: "0 0 57 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8130_31922)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8130_31922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3809 11.1243V26.7697C52.3809 41.018 42.705 53.4419 28.884 56.9404C15.086 53.4534 5.41016 41.018 5.41016 26.7697V11.1243C16.2753 9.90043 22.4295 5.76682 28.8955 0.94043C35.3615 5.76682 41.5157 9.90043 52.3809 11.1243Z",
    fill: "#C02D62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.8955 52.9404C17.633 49.3654 9.89551 38.9154 9.89551 26.9654V15.4904C17.808 13.7654 23.6205 10.5779 28.8955 6.94043C34.283 10.6779 39.983 13.8029 47.8955 15.5029V26.9779C47.8955 38.9154 40.158 49.3654 28.8955 52.9404Z",
    fill: "#CF4476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8130_31922",
    x: 3.41016,
    y: 0.94043,
    width: 50.9707,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8130_31922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8130_31922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8130_31922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 58,
    fill: "white",
    transform: "translate(0.895508 0.94043)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGuard);
export default __webpack_public_path__ + "static/media/heartGuard.9278fdb843fec5198fc29529e2a39004.svg";
export { ForwardRef as ReactComponent };